// extracted by mini-css-extract-plugin
export default {"listHeaderTitle":"ZctOcH","color":"PhA_KU"};